/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MicrophoneRegular from './microphone-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MicrophoneRegular {...validProps} />;
}

SvgComponent.iconName = 'microphoneRegular';

export const MicrophoneRegularIcon = svgIconWrapper(SvgComponent);
